export const environment = {
  production: true,
  APIHOST: 'https://sonthao.guone.vn/service',
  API: 'https://sonthao.guone.vn/',
  APICURRENTSERVE: 'sonthao.guone.vn'
};
